import { useEffect } from 'react';
import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';

/**
 * useAuthSync - Syncs the user's role from the backend on every mount.
 * Uses a separate axios instance to avoid triggering the 401 interceptor.
 */
export default function useAuthSync() {
  useEffect(() => {
    const syncRole = async () => {
      const token = localStorage.getItem('token');
      const storedUser = JSON.parse(localStorage.getItem('user') || 'null');

      if (!token || !storedUser) return;

      try {
        // Use a separate axios call to avoid the 401 redirect interceptor
        const res = await axios.get(`${API_BASE_URL}/auth/me`, {
          headers: { Authorization: `Bearer ${token}` },
          timeout: 5000
        });
        const backendUser = res.data;

        // If role changed in backend, update localStorage
        if (backendUser.role !== storedUser.role) {
          console.log(`Role updated: ${storedUser.role} → ${backendUser.role}`);
          const updatedUser = { ...storedUser, role: backendUser.role };
          localStorage.setItem('user', JSON.stringify(updatedUser));
        }
      } catch (err) {
        // Silently ignore — don't redirect or clear tokens
      }
    };

    syncRole();
  }, []);
}
